<div *ngIf="type === 'reply'" class="chat-message__label">Werfy Support</div>
<div [class.chat-message--reply]="type === 'reply'" class="chat-message">
  <div class="chat-message__body">
    <ng-content></ng-content>
  </div>
  <div [class.chat-message__footer--reply]="type === 'reply'" class="chat-message__footer">
    <ng-content select="[slot=footer]"></ng-content>
  </div>
</div>
